const translations = {
  // Navbar
  'nav.solutions': 'Soluciones',
  'nav.process': 'Proceso',
  'nav.pricing': 'Precios',
  'nav.contact': 'Contacto',
  'nav.blog': 'Blog',
  'nav.challenges': 'Challenges',
  'nav.cta': 'Empezar',

  // Hero section
  'hero.badge': 'Webs y sistemas a precio fijo',
  'hero.titleLine1': 'Tu web en 48 horas.',
  'hero.titleLine2': 'Un precio fijo.',
  'hero.title': 'Synapsis Team',
  'hero.subtitle': 'Landing, portfolio, web de empresa o catálogo: todas cuestan lo mismo. Y no pagás hasta verla terminada y funcionando.',
  'hero.button.start': 'Quiero mi web',
  'hero.button.solutions': 'Ver precios',
  'hero.stat.number1': 'IA Empresarial',
  'hero.stat.number2': 'Automatización',
  'hero.stat.number3': 'Cloud & DevOps',
  'hero.stat.number4': 'Seguridad',
  'hero.stat.website': 'Hablar sobre IA Empresarial',
  'hero.stat.companySystem': 'Hablar sobre Automatización',
  'hero.stat.automatization': 'Hablar sobre Cloud & DevOps',
  'hero.stat.digitalTransformation': 'Hablar sobre Seguridad',
  'hero.stat.consulting': '¡Hola! Quiero hablar sobre',
  'hero.stat.consultingSecondPart': '¿Podemos coordinar una llamada?',

  // Solutions (incluye lo que antes era la sección "Features", ahora unificado)
  'solutions.label': 'Soluciones',
  'solutions.title': 'Soluciones',
  'solutions.titleHighlight': 'a medida',
  'solutions.subtitle': 'Seis frentes de trabajo, un mismo objetivo: que tu negocio corra más rápido y con menos fricción.',
  'solutions.ai.title': 'IA Empresarial',
  'solutions.ai.description': 'Modelos de IA aplicados a problemas reales: predicción de demanda, análisis de datos y automatización de decisiones.',
  'solutions.ai.features': 'Análisis Predictivo,NLP,Computer Vision,Deep Learning',
  'solutions.automation.title': 'Automatización de Procesos',
  'solutions.automation.description': 'Eliminamos tareas repetitivas y conectamos tus herramientas para que el trabajo fluya solo.',
  'solutions.automation.features': 'RPA,Integración de APIs,Flujos de Trabajo,Tareas Programadas',
  'solutions.systems.title': 'Sistemas a Medida',
  'solutions.systems.description': 'ERP, CRM y software interno diseñado para cómo trabaja realmente tu equipo, no al revés.',
  'solutions.systems.features': 'ERP,CRM,BPM,Software a Medida',
  'solutions.cloud.title': 'Cloud & DevOps',
  'solutions.cloud.description': 'Infraestructura escalable y despliegues automatizados, sin sorpresas ni tiempos muertos.',
  'solutions.cloud.features': 'AWS,Azure,GCP,CI/CD',
  'solutions.bi.title': 'Analítica & BI',
  'solutions.bi.description': 'Dashboards y reportes que convierten datos dispersos en decisiones claras.',
  'solutions.bi.features': 'Dashboards,KPIs,Reportes Automáticos,Data Analytics',
  'solutions.security.title': 'Seguridad & Cumplimiento',
  'solutions.security.description': 'Encriptación, monitoreo continuo y buenas prácticas desde el primer día de desarrollo.',
  'solutions.security.features': 'Encriptación,Monitoreo Continuo,Control de Accesos,Backups',
  'solutions.contactUs': 'Hablemos de tu proyecto',

  // Work Process
  'process.label': 'Cómo trabajamos',
  'process.title': 'De la idea',
  'process.titleHighlight': 'al lanzamiento',
  'process.subtitle': 'Cuatro pasos. Sin reuniones de descubrimiento ni ida y vuelta de presupuestos.',
  'process.step1.title': 'Nos escribís',
  'process.step1.description': 'Nos contás qué necesitás y nos pasás tu logo, tus textos si los tenés, y ejemplos que te gusten.',
  'process.step2.title': 'Arrancamos el mismo día',
  'process.step2.description': 'Ya sabés el precio y la fecha, así que no hay nada que presupuestar. Empezamos y listo.',
  'process.step3.title': 'Te la mostramos andando',
  'process.step3.description': 'La ves funcionando de verdad, no un dibujo. Si hay que ajustar algo, se ajusta.',
  'process.step4.title': 'Sale online',
  'process.step4.description': 'Te dejamos el dominio y el hosting configurados, y te explicamos cómo manejarla.',

  // Tech
  'tech.label': 'Stack técnico',
  'tech.title': 'Con qué construimos',

  // Pricing
  'pricing.title': 'Un precio.',
  'pricing.titleHighlight': 'Una fecha.',
  'pricing.subtitle': 'Lo que ves es lo que pagás. Sin plan básico, premium y empresarial. Sin cuotas que aparecen después.',
  'pricing.currency': '$',
  'pricing.currencyCode': 'ARS',
  'pricing.period': '',

  'pricing.web.name': 'Página web',
  'pricing.web.price': '25.000',
  'pricing.web.delivery': 'Lista en 48 horas',
  'pricing.web.description': 'Landing, portfolio, web de empresa o catálogo. Todas al mismo precio.',
  'pricing.web.feature1': 'Diseño propio, hecho para tu marca',
  'pricing.web.feature2': 'Textos escritos e incluidos',
  'pricing.web.feature3': 'Se ve perfecta en celular y computadora',
  'pricing.web.feature4': 'Formulario de contacto que te avisa por mail',
  'pricing.web.feature5': 'Preparada para Google desde el día uno',
  'pricing.web.feature6': 'WhatsApp y redes conectados',
  'pricing.web.feature7': 'Dominio, hosting y código: todo queda a tu nombre',
  'pricing.web.cta': 'Quiero mi web',

  'pricing.system.name': 'Sistema web',
  'pricing.system.price': '120.000',
  'pricing.system.delivery': 'Listo en 7 días',
  'pricing.system.description': 'Para operar tu negocio. Entrás desde el navegador, sin instalar nada.',
  'pricing.system.feature1': 'Elegís qué hace: turnos, pedidos, stock, clientes, facturación o gestión interna',
  'pricing.system.feature2': 'Usuarios con permisos: cada uno ve lo suyo',
  'pricing.system.feature3': 'Panel de administración para manejarlo vos',
  'pricing.system.feature4': 'Base de datos con tu información, siempre tuya',
  'pricing.system.feature5': 'Funciona desde cualquier computadora o celular',
  'pricing.system.feature6': 'Copias de seguridad automáticas',
  'pricing.system.feature7': 'Te enseñamos a usarlo en una llamada',
  'pricing.system.cta': 'Quiero mi sistema',

  'pricing.guarantee': 'No pagás hasta verlo terminado y funcionando.',
  'pricing.guaranteeSub': 'Lo armamos, te lo mostramos andando, y recién ahí hablamos de plata.',
  'pricing.customSolution': '¿Necesitás algo más grande?',
  'pricing.contactUs': 'Contanos qué tenés en mente',

  // FAQ
  'faq.label': 'Preguntas frecuentes',
  'faq.title': 'Antes de',
  'faq.titleHighlight': 'empezar',
  'faq.q1': '¿En serio 48 horas?',
  'faq.a1': 'Sí. Nos mandás tu información un lunes y el miércoles tenés la web andando. Podemos hacerlo porque no reinventamos nada en cada proyecto: ya tenemos resuelta la parte técnica y nos concentramos en lo tuyo.',
  'faq.q2': '¿El precio es ese o después aparecen extras?',
  'faq.a2': 'Es ese. Incluye diseño, textos, la web funcionando y el dominio y el hosting configurados. No hay costo de mantenimiento obligatorio ni sorpresas en el mes dos.',
  'faq.q3': '¿Y si no me gusta?',
  'faq.a3': 'La ajustamos. No pagás hasta que la veas terminada y te guste, así que el riesgo lo corremos nosotros, no vos.',
  'faq.q4': '¿Puedo cambiar cosas yo después?',
  'faq.a4': 'Los textos y las imágenes, sí: te dejamos todo para que los edites sin saber programar. Y si querés que hagamos un cambio, nos escribís y lo hacemos.',
  'faq.q5': '¿Qué diferencia hay entre la web y el sistema?',
  'faq.a5': 'La web es tu presencia: te encuentran, ven lo que hacés y te contactan. El sistema es tu herramienta de trabajo: manejás turnos, pedidos, stock o clientes desde adentro. Muchos empiezan por la web y suman el sistema cuando crecen.',
  'faq.q6': '¿Trabajan con empresas de otros países?',
  'faq.a6': 'Sí. Trabajamos con clientes en Argentina y Estados Unidos, todo a distancia. La zona horaria no fue nunca un problema.',

  // CTA / Contact
  'cta.title': 'Hablemos de tu',
  'cta.titleHighlight': 'proyecto',
  'cta.subtitle': '¿Tenés un problema técnico o una idea en mente? Contanos qué necesitás.',
  'cta.feature1.title': 'Respuesta rápida',
  'cta.feature1.subtitle': 'Te contestamos sin pasar por capas de gestión intermedias.',
  'cta.feature2.title': 'Comunicación directa',
  'cta.feature2.subtitle': 'Hablás con quien va a desarrollar tu proyecto, no con un comercial.',
  'cta.feature3.title': 'Fecha que se cumple',
  'cta.feature3.subtitle': 'Te damos un día concreto y ese día está lista. Sin excusas.',
  'cta.form.name': 'Nombre',
  'cta.form.namePlaceholder': 'Tu nombre',
  'cta.form.email': 'Email',
  'cta.form.emailPlaceholder': 'Tu email',
  'cta.form.company': 'Empresa',
  'cta.form.companyPlaceholder': 'Tu empresa',
  'cta.form.message': 'Mensaje',
  'cta.form.messagePlaceholder': 'Contanos sobre tu proyecto',
  'cta.form.successTitle': '¡Mensaje enviado!',
  'cta.form.successMessage': 'Tu mensaje ha sido enviado correctamente. Nos pondremos en contacto contigo pronto.',
  'cta.form.errorTitle': 'Error',
  'cta.form.errorMessage': 'Ha ocurrido un error al enviar el mensaje. Por favor, inténtalo de nuevo.',
  'cta.form.sending': 'Enviando...',
  'cta.form.sendAnother': 'Enviar otro mensaje',
  'cta.form.tryAgain': 'Intentar de nuevo',
  'cta.button': 'Enviar mensaje',

  // Footer
  'footer.companyDescription': 'Synapsis Team diseña, construye y mantiene software, IA y automatización para empresas que quieren moverse más rápido.',
  'footer.quickLinks': 'Enlaces Rápidos',
  'footer.contact': 'Contacto',
  'footer.privacy': 'Política de Privacidad',
  'footer.terms': 'Términos y Condiciones',
  'footer.cookies': 'Política de Cookies',
  'footer.rights': `© ${new Date().getFullYear()} Synapsis Team. Todos los derechos reservados.`,

  // Cookie consent
  'cookie.message': 'Usamos cookies para entender cómo se usa el sitio y mejorarlo. Podés rechazarlas y el sitio funciona igual. Más detalle en nuestra',
  'cookie.manage': 'Gestionar cookies',
  'cookie.link': 'política de cookies',
  'cookie.accept': 'Aceptar',
  'cookie.reject': 'Rechazar',
};

export default translations;
